<template>
  <div class="phone">
    <vs-tooltip :text="this.params ? this.params.data.country_details.country_name : this.country_name" color="primary">
      <country-flag :country="this.params ? this.params.data.country_details.country_code : this.country_code" size="normal" class="phone-img" />
    </vs-tooltip>
    <div>
      <strong v-if="!this.params" class="block pl-2">Contact:</strong>
      <span class="phone-number">{{
        this.params ? this.params.value : this.phone
      }}</span>
    </div>
  </div>
</template>

<script>
import CountryFlag from 'vue-country-flag'

export default {
  name: "PhoneImageCell",
  props: {
    phone: String,
    country_code: String,
    country_name: String
  },
  components: {
    CountryFlag
  },
  data () {
    return {
    }
  },
};
</script>
<style>
.phone {
  display: flex;
  align-items: center;
}
.phone-img {
  border-radius: 50%;
  align-items: center;
  margin-bottom: unset !important;
}

.phone-number {
  margin-left: 8px !important;
  color: #5e5873 !important;
}
</style>
